export default __webpack_public_path__ + "static/felipe-985d6a4c581887466279fdfb0939e0d0.jpg";